var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConductinline = function SvgConductinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00877C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 13h-24c-2.481 0-4.5 2.131-4.5 4.75v27.708C17 48.514 19.355 51 22.25 51H45.5c.83 0 1.5-.71 1.5-1.583V14.583C47 13.71 46.33 13 45.5 13M44 47.833H22.25c-1.24 0-2.25-1.065-2.25-2.375s1.01-2.375 2.25-2.375H44v4.75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 10,
    fill: "#00877C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F6F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m28 28 2.667 3L36 25"
  })));
};
export default SvgConductinline;